/*
  Enwrape custom behaviour.
  Replaces five inline script blocks that previously sat at the bottom of
  layout/theme.liquid, so this code is browser-cacheable instead of being
  re-sent inside the HTML on every page view.

   1. Variant sync - keeps EVERY add-to-cart form on the chosen variant.
   2. Mega menu hover (null-guarded)
   3. Footer accordion (mobile) with correct aria-expanded
   4. Recently-viewed tracking
   5. Sticky add-to-cart bar (IntersectionObserver, no scroll thrash)
*/
(function () {
  'use strict';

  /* ---------------------------------------------------------------- *
   * 1. VARIANT SYNC - fixes the wrong saree being added on mobile.
   *
   * buy-buttons is rendered twice: one copy inside <product-info>
   * (.desk-only, shown on desktop) and one outside it in
   * .product-bottom-buttons (the fixed bar shown at <=768px).
   *
   * Dawn's product-info.js scopes updateVariantInputs() to itself, so the
   * copy OUTSIDE <product-info> never gets the new variant id. On mobile,
   * picking any colour other than the default still added the DEFAULT
   * variant to the cart.
   *
   * We mirror the authoritative value outward after every re-render rather
   * than restructuring the 113KB product section, which would risk the
   * Fastrr checkout binding. <product-info> replaces its own innerHTML on
   * variant change, so a subtree observer catches every update.
   * ---------------------------------------------------------------- */
  function syncVariantInputs() {
    var info = document.querySelector('product-info');
    if (!info) return;

    var source = info.querySelector('input.product-variant-id');
    if (!source || !source.value) return;

    var all = document.querySelectorAll('input.product-variant-id');
    for (var i = 0; i < all.length; i++) {
      var input = all[i];
      if (info.contains(input)) continue;
      if (input.value === source.value) continue;
      input.value = source.value;
      // Mirror availability too, so an outside form cannot submit a
      // variant the inner form has already marked unpurchasable.
      if (source.disabled) {
        input.setAttribute('disabled', 'disabled');
      } else {
        input.removeAttribute('disabled');
      }
    }

    // Keep the outer submit button's disabled state honest as well.
    var innerBtn = info.querySelector('button[name="add"]');
    if (!innerBtn) return;
    var buttons = document.querySelectorAll('button[name="add"]');
    for (var j = 0; j < buttons.length; j++) {
      var btn = buttons[j];
      if (info.contains(btn)) continue;
      btn.disabled = innerBtn.disabled;
      var innerLabel = innerBtn.querySelector('span');
      var outerLabel = btn.querySelector('span');
      if (innerLabel && outerLabel) outerLabel.textContent = innerLabel.textContent;
    }
  }

  function watchVariants() {
    var info = document.querySelector('product-info');
    if (!info) return;
    syncVariantInputs();
    var observer = new MutationObserver(function () { syncVariantInputs(); });
    observer.observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
    // Belt and braces: also run straight after any variant control changes,
    // in case a future theme update stops replacing the subtree.
    document.addEventListener('change', function (e) {
      if (e.target.closest && e.target.closest('variant-selects')) {
        setTimeout(syncVariantInputs, 0);
        setTimeout(syncVariantInputs, 600);
      }
    });
  }

  /* ---------------------------------------------------------------- *
   * 2. MEGA MENU HOVER
   * Previously threw a TypeError on any .mega-menu-li without a nested
   * <details>, which aborted the handler for that item.
   * ---------------------------------------------------------------- */
  function megaMenu() {
    document.querySelectorAll('.mega-menu-li').forEach(function (li) {
      var details = li.querySelector('details');
      if (!details) return;
      var timeout;
      li.addEventListener('mouseenter', function () {
        clearTimeout(timeout);
        details.setAttribute('open', true);
      });
      li.addEventListener('mouseleave', function () {
        timeout = setTimeout(function () { details.removeAttribute('open'); }, 150);
      });
    });
  }

  /* ---------------------------------------------------------------- *
   * 3. FOOTER ACCORDION (mobile)
   * Same behaviour as before, plus aria-expanded is now kept truthful
   * so screen readers announce the real state.
   * ---------------------------------------------------------------- */
  function footerAccordion() {
    if (window.innerWidth > 768) return;
    var blocks = document.querySelectorAll('.footer-block');

    function paint(block, open) {
      var content = block.querySelector('.footer-block__details-content');
      var btn = block.querySelector('.footer-toggle-btn');
      if (content) content.style.display = open ? 'block' : 'none';
      if (btn) {
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var plus = btn.querySelector('.toggle-plus');
        var minus = btn.querySelector('.toggle-minus');
        if (plus) plus.style.display = open ? 'none' : 'inline';
        if (minus) minus.style.display = open ? 'inline' : 'none';
      }
    }

    blocks.forEach(function (block) {
      if (!block.querySelector('.footer-block__details-content')) return;
      paint(block, block.dataset.open === 'true');

      block.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var content = block.querySelector('.footer-block__details-content');
        var isOpen = content && content.style.display === 'block';
        blocks.forEach(function (b) { paint(b, false); });
        if (!isOpen) paint(block, true);
      });
    });
  }

  /* ---------------------------------------------------------------- *
   * 4. RECENTLY VIEWED
   * ---------------------------------------------------------------- */
  function recentlyViewed() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="/products/"]');
      if (!link) return;
      try {
        var url = new URL(link.href);
        var parts = url.pathname.split('/');
        var handle = parts[parts.indexOf('products') + 1];
        if (!handle) return;
        var recent = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
        recent = recent.filter(function (item) { return item !== handle; });
        recent.unshift(handle);
        localStorage.setItem('recentlyViewed', JSON.stringify(recent.slice(0, 15)));
      } catch (err) { /* private mode or blocked storage - ignore */ }
    });
  }

  /* ---------------------------------------------------------------- *
   * 5. STICKY ADD TO CART
   * Was a non-passive scroll listener calling getBoundingClientRect() on
   * every frame - the classic cause of janky scrolling on mid-range
   * Android. Now an IntersectionObserver: zero scroll listeners, zero
   * forced layout.
   * ---------------------------------------------------------------- */
  function stickyAtc() {
    var bar = document.getElementById('sticky-atc-bar');
    var stickyBtn = document.getElementById('sticky-atc-btn');
    if (!bar || !stickyBtn) return;

    var info = document.querySelector('product-info');
    var originalBtn = (info && info.querySelector('button[name="add"]')) ||
                      document.querySelector('button[name="add"], [id^="ProductSubmitButton"], .product-form__submit');
    if (!originalBtn) return;

    function syncState() {
      var disabled = originalBtn.disabled || originalBtn.hasAttribute('disabled') || originalBtn.classList.contains('disabled');
      stickyBtn.disabled = disabled;
      stickyBtn.style.cursor = disabled ? 'not-allowed' : 'pointer';
      stickyBtn.style.opacity = disabled ? '0.5' : '1';
    }
    syncState();
    new MutationObserver(syncState).observe(originalBtn, { attributes: true });

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('hidden', entry.isIntersecting || entry.boundingClientRect.top > 0);
      });
    }, { threshold: 0 }).observe(originalBtn);

    stickyBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (stickyBtn.disabled) return;
      var stickyQty = document.getElementById('sticky-qty');
      var qty = stickyQty ? stickyQty.value : '1';
      var mainQty = (info && info.querySelector('input[name="quantity"]')) || document.querySelector('input[name="quantity"]');
      if (mainQty) mainQty.value = qty;
      syncVariantInputs();
      stickyBtn.classList.add('loading');
      var spinner = stickyBtn.querySelector('.loading-spinner');
      if (spinner) spinner.classList.remove('hidden');
      originalBtn.click();
      setTimeout(function () {
        stickyBtn.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      }, 1000);
    });
  }

  /* ---------------------------------------------------------------- *
   * Removed: the "N people are viewing this" counter, which filled the
   * badge with Math.random() between 4 and 60. Invented scarcity is a
   * listed dark pattern under India's 2023 guidelines. Any leftover
   * markup is hidden so no empty sentence is shown.
   * ---------------------------------------------------------------- */
  function hideFakeViewers() {
    var el = document.getElementById('dynamic-viewer-count');
    if (!el) return;
    var host = el.closest('.cus-viewer-line, .viewers-text, p, span') || el;
    host.style.display = 'none';
  }

  function init() {
    watchVariants();
    megaMenu();
    footerAccordion();
    recentlyViewed();
    stickyAtc();
    hideFakeViewers();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
